import clsx from 'clsx';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var HanaDisclaimer = function HanaDisclaimer(_ref) {
  var className = _ref.className,
    containerClassName = _ref.containerClassName,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? '' : _ref$text,
    linkText = _ref.linkText,
    linkHref = _ref.linkHref,
    show = _ref.show,
    shorterText = _ref.shorterText,
    variant = _ref.variant;
  if (!show) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    className: clsx('tw-font-body5 tw-text-neutral-light-700 tw-flex tw-justify-center', containerClassName),
    children: shorterText ? /*#__PURE__*/_jsxs("div", {
      children: [variant === 'main-chat' && /*#__PURE__*/_jsx("div", {
        className: "tw-hidden sm:tw-block",
        children: /*#__PURE__*/_jsxs("p", {
          className: clsx('tw-text-center tw-whitespace-pre-line', className),
          children: [text, ' ', linkText && linkHref && /*#__PURE__*/_jsx("a", {
            href: linkHref,
            target: "_blank",
            rel: "noopener noreferrer",
            className: "tw-underline hover:tw-no-underline",
            children: linkText
          })]
        })
      }), /*#__PURE__*/_jsx("div", {
        className: clsx('tw-block', {
          'sm:tw-hidden': variant === 'main-chat'
        }),
        children: /*#__PURE__*/_jsx("a", {
          href: linkHref,
          target: "_blank",
          rel: "noopener noreferrer",
          className: clsx('tw-underline hover:tw-no-underline tw-text-center', {
            'tw-cds-font-subtitle-03': variant === 'floating-chat'
          }),
          children: shorterText
        })
      })]
    }) : /*#__PURE__*/_jsxs("p", {
      className: clsx('tw-text-center tw-whitespace-pre-line', {
        'tw-cds-font-subtitle-03': variant === 'floating-chat'
      }),
      children: [text, ' ', /*#__PURE__*/_jsx("a", {
        href: linkHref,
        target: "_blank",
        rel: "noopener noreferrer",
        className: clsx('tw-underline hover:tw-no-underline', {
          'tw-cds-font-subtitle-03': variant === 'floating-chat'
        }),
        children: linkText
      })]
    })
  });
};